const ANALYTICS_GROUP = 'C0002';
const CONSENT_EVENT = 'ot-consent-changed';

declare global {
  interface Window {
    OnetrustActiveGroups?: string;
  }
}

export const getConsentGroups = (): string[] =>
  (window.OnetrustActiveGroups ?? '').split(',').filter(Boolean);

export const hasAnalyticsConsent = (): boolean =>
  getConsentGroups().includes(ANALYTICS_GROUP);

/** True once the OneTrust SDK has reported consent state at least once. */
export const isConsentKnown = (): boolean =>
  typeof window.OnetrustActiveGroups === 'string';

/**
 * Pre-SDK consent hint from the persisted OneTrust cookie (groups=...,C0002:1,...).
 * Returns undefined when the banner was never answered (first visit).
 */
export const getConsentHintFromCookie = (): boolean | undefined => {
  const raw = document.cookie
    .split('; ')
    .find(row => row.startsWith('OptanonConsent='))
    ?.substring('OptanonConsent='.length);
  if (!raw) return undefined;

  const groups = new URLSearchParams(raw).get('groups');
  if (!groups) return undefined;

  return groups.split(',').includes(`${ANALYTICS_GROUP}:1`);
};

/** Subscribe to consent changes. Returns an unsubscribe function. */
export const onConsentChanged = (callback: () => void): (() => void) => {
  const handler = () => callback();
  window.addEventListener(CONSENT_EVENT, handler);
  return () => window.removeEventListener(CONSENT_EVENT, handler);
};
